
function styleTitles() {
  const titles = document.querySelectorAll('.title');

  for (let title of titles) {
    const titleParts = title.textContent.trim().split(' ');

    if(titleParts.length > 1) {
      titleParts[0] = `<span>${titleParts[0]}</span>`;
    }

    title.innerHTML = titleParts.join(' ');
  }
}

function handleAccordionToggling() {
  const productAccordions = document.querySelectorAll('.product__accordion');

  for (let accordion of productAccordions) {
    accordion.addEventListener('click', () => {
      const isOpen = accordion.classList.contains('is-active');

      for (let item of productAccordions) {
        item.classList.remove('is-active');
        item.querySelector('details')?.removeAttribute("open");
      }

      if(isOpen) {
        accordion.classList.remove('is-active');

        setTimeout(() => {
          accordion.querySelector('details')?.removeAttribute("open");
        }, 50);
      } else {
        accordion.classList.add('is-active');
      }
    });
  }
}

function hideElements(baseElements, nodeToHide) {
  for (element of baseElements) {
    if(element.textContent === 'filter-hidden')	{
        element.closest(nodeToHide)?.classList.add('hidden');
    }
  }
}

function hideFilters() {
  const filterLabelElements = document.querySelectorAll('.facet-checkbox__text-label');
  const showMoreBtns = document.querySelectorAll('.button-show-more');

  hideElements(filterLabelElements, '.facets__item');

  for (let button of showMoreBtns) {
    button.addEventListener('click', () => {
      setTimeout(() => hideElements(filterLabelElements, '.facets__item'), 200);
    });
  }
}

function indentFilters() {
  try {
    const legends = document.querySelectorAll('fieldset.facets-wrap > legend');
    let vanArea; // essentially a <ul/> element
    
    legends.forEach((legend) => {
      if(legend.textContent.toLowerCase() === "van area") {
        vanArea = legend.nextElementSibling
      }
    });
  
    const items = vanArea.querySelectorAll('li');
  
    items.forEach((item) => {
      const text = item.querySelector('.facet-checkbox__text-label').textContent.toLowerCase();
      if(text !== "exterior" && text !== "interior") {
        item.style.paddingLeft = "2.95rem";
      }
    }); 
    
  } catch (error) {
    
  }
}

function collapseFilters() {
  try {
    const filters = document.querySelectorAll('details.js-filter');

    filters.forEach((filter) => {
      filter.removeAttribute('open');
    });
  } catch (error) {
    
  }
}

function handleFacetLabelClicks() {
  const facetLabels = document.querySelectorAll('.facets__label');

  facetLabels.forEach((label) => {
    label.addEventListener('click', () => {

      setTimeout(() => {
        console.log('clicked label');
        
        indentFilters();
        hideFilters();
      }, 1500);
    });
  })
}


function init() {
  styleTitles();
  handleAccordionToggling();
  hideFilters();
  collapseFilters();

  // delayed functions
  setTimeout(() => {
    styleTitles();
    indentFilters();
    handleFacetLabelClicks();
  }, 800);

  // window.addEventListener('load', () => {
  //   console.log('window load event');
  // });
  // window.addEventListener('hashchange', () => {
  //   console.log('hashchange event');
  // });
  // window.addEventListener('popstate', () => {
  //   console.log('popstate event');
  // });

  // window.addEventListener('locationchange', function () {
  //   console.log('location changed!');
  // });
}

init();


const observeUrlChange = () => {
  let oldHref = document.location.href;
  const body = document.querySelector('body');
  const observer = new MutationObserver(mutations => {
    if (oldHref !== document.location.href) {
      oldHref = document.location.href;
      /* Changed ! your code here */
      console.log('url has been updated');
      indentFilters();
      hideFilters();
    }
  });
  observer.observe(body, { childList: true, subtree: true });
};

window.onload = observeUrlChange;











